export const LOAD_APPS_SUCCESS = "LOAD_APPS_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const VALIDATE_USER_SUCCESS = "VALIDATE_USER_SUCCESS";
export const LOAD_DOCUMENTS_SUCCESS = "LOAD_DOCUMENTS_SUCCESS";
